module.exports = __webpack_public_path__ + "img/menu-team-yellow.96bb9684.svg";